import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';

export const sessionLost = createAction(
  `${reduxKey}.DAMZ_SESSION_LOST`,
  (reconnect: () => Promise<void>) => ({ reconnect })
);
